/**
 * Per-size bottle pricing (10 / 20 / 50 / 100 ML).
 *
 * Prices are stored per size in the database (`price_50ml_cents`,
 * `price_100ml_cents`, `price_10ml_cents`, `price_20ml_cents`). No multipliers
 * are used anywhere.
 */
export type BottleSizeId = "10" | "20" | "50" | "100";

export const BOTTLE_SIZE_IDS: BottleSizeId[] = ["10", "20", "50", "100"];

export type SizePrices = Record<BottleSizeId, number>;

type PricedProduct = { price?: number; prices?: Partial<SizePrices> | null };

/** Resolves the size prices, falling back to the legacy single price. */
export function sizePrices(product: PricedProduct): SizePrices {
  const legacy = product.price ?? 0;
  const p = product.prices ?? {};
  return {
    "10": p["10"] ?? 0,
    "20": p["20"] ?? 0,
    "50": p["50"] ?? legacy,
    "100": p["100"] ?? legacy,
  };
}

/** Price for a single bottle size. */
export function priceForSize(product: PricedProduct, size: BottleSizeId | string): number {
  const prices = sizePrices(product);
  return prices[(size as BottleSizeId) in prices ? (size as BottleSizeId) : "50"];
}

/** "Starting from" price shown on cards and listings = the 50 ML price. */
export function startingPrice(product: PricedProduct): number {
  return sizePrices(product)["50"];
}
